<template>
  <div id="app">

     <router-view></router-view>


    <bgmusic></bgmusic>
  </div>
</template>

<script>
import bgmusic from "@/view/bgmusic/bgmusic";
export default {
  name: "App",
  components: { bgmusic },
  data() {
    return {};
  },
  methods: {
    //处理微信浏览器音乐自动播放问题
    audioAutoPlay() {
      var audio = document.getElementById("bg_music");
      audio.play();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          audio.play();
        },
        false
      );
    },
    //解决所有浏览器音乐自动播放的问题
    autoPlayMusic() {
      let _this = this;
      /* 自动播放音乐效果，解决浏览器或者APP自动播放问题 */
      function musicInBrowserHandler() {
        _this.musicPlay(true);
        document.body.removeEventListener("touchstart", musicInBrowserHandler);
      }
      document.body.addEventListener("touchstart", musicInBrowserHandler);
      /* 自动播放音乐效果，解决微信自动播放问题 */
      function musicInWeixinHandler() {
        _this.musicPlay(true);
        document.addEventListener(
          "WeixinJSBridgeReady",
          function () {
            _this.musicPlay(true);
          },
          false
        );
        document.removeEventListener("DOMContentLoaded", musicInWeixinHandler);
      }
      document.addEventListener("DOMContentLoaded", musicInWeixinHandler);
    },
    //音乐状态判断
    musicPlay(isPlay) {
      var media = document.getElementById("bg_music");
      if (isPlay && media.paused) {
        media.play();
      }
      if (!isPlay && !media.paused) {
        media.pause();
      }
    },
  },
    mounted(){
      let _this = this;
      _this.autoPlayMusic();//调用所有浏览器自动音乐播放的函数
      _this.audioAutoPlay();//调用微信浏览器自动音乐播放的函数
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue